import React from 'react';
import resolvePath from '../../../misc/resolvePath';
import Icon from '../../elements/icons/Icon';
import Link from '../../elements/Link';
import EventImageAttachment from './EventImageAttachment';
import EventVideoAttachment from './EventVideoAttachment';

export default class EventAttachment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: false,
            url: '',
        };

        let type = props.attachment.type || props.attachment.mimetype;
        if (type.match(/image/)) {
            this.state.type = 'image';
            this.state.url = props.attachment.full_url || URL.createObjectURL(props.attachment);
        } else if (type.match(/video/)) {
            this.state.type = 'video';
            this.state.url = props.attachment.media_url || URL.createObjectURL(props.attachment);
        }
    }
    componentDidMount() {
        if (!this.state.type) {
            console.warn('Unknown attachment type: ', this.props.attachment);
            app.history.replace(resolvePath(app.history.location.pathname, '..'));
        }
    }
    render() {
        let icons = _.compact([
            this.props.allowDelete ? (
                <Link key="delete" onClick={this.props.onDelete}>
                    <Icon icon="trash" />
                </Link>
            ) : null,
        ]);

        switch (this.state.type) {
            case 'image':
                return <EventImageAttachment icons={icons} {...this.props} src={this.state.url} />;
            case 'video':
                return <EventVideoAttachment icons={icons} {...this.props} src={this.state.url} />;
        }
        return null;
    }
}
